const tokenName = 'authToken';

export const onSignIn = (token: string): void =>
	localStorage.setItem(tokenName, token);

export const onSignOut = (): void => localStorage.removeItem(tokenName);

export const getToken = (): string | null => localStorage.getItem(tokenName);

export const isSignedIn = (): boolean => !!localStorage.getItem(tokenName);
